import React, { useState } from 'react'
import backarrow from '../../../assets/images/back-arrow.svg'
import ManualPaymentForm from '../../../forms/ManualPayment/ManualPaymentForm'
import { formatrates } from "../../../functions/Utils";

const ManualPayment = ({props,setBookingType, nodeData,setOpen1,open1,queryId, selectedItem, paymentId, remainingBalance, useCreditAmount}) => {
    console.log(nodeData,"nodeData");
    const [paymentDetailsForm, setPaymentDetailsForm] = useState(false)
    // console.log(open1,remainingBalance,selectedItem,"openmp");
    return (
        <div className='flex flex-col gap-2 w-full'>
            <div className="flex w-full">
                <img src={backarrow} alt="Back Arrow" className='cursor-pointer'  onClick={()=> { 
                    setPaymentDetailsForm(false); 
                    setBookingType && setBookingType(''); }} />
                <p className="font-bold leading-4 text-lg px-4 py-2.5 text-center w-full">Payment Details</p>
            </div>
            <hr className='border-primary my-2'/>
            {
                !paymentDetailsForm ? 
                <>
                    <p className="font-normal leading-6 text-sm px-4 py-2.5 text-center w-full "> Please find the below bank details to make payment via IMPS/NEFT/RTGS</p>
                    <div className="flex flex-col">
                        <p className="font-bold leading-4 text-base px-4 py-2.5 text-center w-full ">Bank Details</p>
                        <div className="flex items-center justify-between">
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-start w-full ">Name of Bank :</p>
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-end w-full ">Federal Bank</p>
                        </div>
                        <div className="flex items-center justify-between">
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-start w-full ">Account number :</p>
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-end w-full ">13710100108888</p>
                        </div>
                        <div className="flex items-center justify-between">
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-start w-full ">IFSC :</p>
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-end w-full ">FDRL0001371</p>
                        </div>
                        <div className="flex items-center justify-between">
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-start w-full ">Branch :</p>
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-end w-full ">Kalady</p>
                        </div>
                        <div className="flex items-center justify-between">
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-start w-full ">Account Holder Name :</p>
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-end w-full ">John Doe</p>
                        </div>
                        <div className="flex items-center justify-between">
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-start w-full ">Total Amount :</p>
                            {/* <p className="font-bold leading-4 text-sm px-4 py-2.5 text-end w-full ">{selectedItem?.USD_totalFreightRate ? `$ ${selectedItem?.USD_totalFreightRate} (₹ ${selectedItem?.totalFreightRate})` : `₹ ${selectedItem?.totalFreightRate}`}</p> */}
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-end w-full ">{` ${ formatrates(selectedItem?.rateDetails?.totalAmount)    }`}</p>
                        </div>
                        <div className="flex items-center justify-between">
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-start w-full ">Payable Amount :</p>
                            <p className="font-bold leading-4 text-sm px-4 py-2.5 text-end w-full ">{`${formatrates(remainingBalance)}`}</p>
                        </div>
                    </div>
                    <p className="font-normal leading-5 text-xs px-4 py-2.5 text-center w-full ">Please click on “Next” after making the payment as you will be asked to enter transaction details for a successful booking.</p>
                    <button  onClick={()=>setPaymentDetailsForm(true)} type="submit" className="text-white bg-primary hover:bg-secondary font-bold leading-4 rounded-lg text-sm px-4 py-2.5 text-center  flex items-center justify-center gap-2 shadow-searchbox w-full flex-wrap">
                        NEXT
                    </button>
                </>
                :
                    <ManualPaymentForm props={props} setOpen1={setOpen1} open1={open1} nodeData={nodeData} setBookingType={setBookingType} queryId={queryId} selectedItem={selectedItem} paymentId={paymentId} remainingBalance={remainingBalance} useCreditAmount={useCreditAmount}/>
            }
        </div>
    )
}

export default React.memo(ManualPayment)